<template>
  <section class="w-100 px-4 d-flex flex-column">
    <Button
      class="cta-t-c w-100 text-start"
      @click="$emit('open-document', 'termsConditions')"
    >
      {{ t("CL_CONTRACT.SEE_TYC") }}
      <span class="ms-3 text-end float-end">&#10095;</span>
    </Button>
    <hr class="p-0 m-0" />
    <Button
      class="cta-t-c w-100 text-start"
      @click="$emit('open-document', 'contract')"
    >
      {{ t("CL_CONTRACT.SEE_CONTRACT") }}
      <span class="ms-3 text-end float-end">&#10095;</span>
    </Button>
    <hr class="p-0 m-0" />
    <!--////////////SIGNATURE////////////-->
    <div class="mt-3">
      <VueSignaturePad
        width="100%"
        height="125px"
        ref="signaturePadRef"
        class="signature-pad"
        :options="{ onEnd: onSignatureEnd }"
      />
      <div class="d-flex justify-content-between">
        <h6 class="text-right mt-2 clear-signature" @click="clearSignature">
          {{ t("CLEARSIGNATURE") }}
        </h6>
      </div>
    </div>
    <div class="form-check py-1 mt-1" v-if="showMarketingCommunications">
      <input
        type="checkbox"
        class="checkbox form-check-input"
        id="preference-checkbox"
        :checked="marketingCommunications"
        @change="
          $emit(
            'update:marketingCommunications',
            ($event.target as HTMLInputElement).checked
          )
        "
        data-testid="checkbox"
      />
      <label
        for="preference-checkbox"
        class="form-check-label ms-2 my-auto fst-italic fw-light"
        >{{ t("CL_CONTRACT_MARKETING_CHECKBOX") }}</label
      >
    </div>
    <p id="pgraf-terms" class="mt-3 mb-0 pb-0">
      {{ t("CL_CONTRACT.DISCLAIMER") }}
    </p>
  </section>
</template>

<script setup lang="ts">
import { ref, Ref } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { VueSignaturePad } from "vue-signature-pad";
import Button from "@/apps/credit-line/components/Button.vue";

defineProps<{
  showMarketingCommunications?: boolean;
  marketingCommunications?: boolean;
}>();

const emit = defineEmits<{
  (e: "signature-drawn"): void;
  (e: "signature-cleared"): void; // Event for when signature is cleared
  (e: "open-document", type: "termsConditions" | "contract"): void;
  (e: "update:marketingCommunications", value: boolean): void;
}>();

const { t } = useI18n();
const signaturePadRef = ref() as Ref<typeof VueSignaturePad>;

const onSignatureEnd = () => {
  emit("signature-drawn");
};

const clearSignature = () => {
  signaturePadRef.value.clearSignature();
  emit("signature-cleared");
};

const getSignature = () => {
  return signaturePadRef.value.saveSignature();
};

defineExpose({
  getSignature,
  clearSignature,
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/constants";

#pgraf-terms {
  color: var(--text-grey-dark, #666);
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
}

.cta-t-c {
  color: var(--main-primary-500, #2c7040);
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  border: none;
  background-color: transparent;
  margin: 9px 0;
  padding: 0;
  text-align: left;
}

.signature-pad {
  border-radius: 25px;
  border-color: $pj-color-light-gray;
  border-width: thin;
  border-style: solid;
}

.clear-signature {
  color: #2c7040;
  cursor: pointer;
}

#preference-checkbox {
  height: 1rem;
  width: 1rem;
}

label {
  cursor: pointer;
  color: $pj-color-green;
  font-weight: bold;
  font-size: medium;
}

.checkbox {
  box-shadow: none;
  outline: none;
  border-color: $pj-color-green;

  &:checked {
    background-color: $pj-color-green;
    color: $pj-color-green;
    outline: none;
    border: 0;
    box-shadow: none;
  }
}
</style>
